/**
 * @fileoverview gRPC-Web generated client stub for witbooking.backoffice.enginemulticonfig.v1
 * @enhanceable
 * @public
 */

// GENERATED CODE -- DO NOT EDIT!



const grpc = {};
grpc.web = require('grpc-web');


var validate_validate_pb = require('../../../../validate/validate_pb.js')
const proto = {};
proto.witbooking = {};
proto.witbooking.backoffice = {};
proto.witbooking.backoffice.enginemulticonfig = {};
proto.witbooking.backoffice.enginemulticonfig.v1 = require('./engine_multi_config_api_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?Object} options
 * @constructor
 * @struct
 * @final
 */
proto.witbooking.backoffice.enginemulticonfig.v1.EngineMultiConfigAPIClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options['format'] = 'binary';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?Object} options
 * @constructor
 * @struct
 * @final
 */
proto.witbooking.backoffice.enginemulticonfig.v1.EngineMultiConfigAPIPromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options['format'] = 'binary';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.backoffice.enginemulticonfig.v1.CreateEngineMultiConfigRequest,
 *   !proto.witbooking.backoffice.enginemulticonfig.v1.CreateEngineMultiConfigResponse>}
 */
const methodDescriptor_EngineMultiConfigAPI_CreateEngineMultiConfig = new grpc.web.MethodDescriptor(
  '/witbooking.backoffice.enginemulticonfig.v1.EngineMultiConfigAPI/CreateEngineMultiConfig',
  grpc.web.MethodType.UNARY,
  proto.witbooking.backoffice.enginemulticonfig.v1.CreateEngineMultiConfigRequest,
  proto.witbooking.backoffice.enginemulticonfig.v1.CreateEngineMultiConfigResponse,
  /**
   * @param {!proto.witbooking.backoffice.enginemulticonfig.v1.CreateEngineMultiConfigRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.enginemulticonfig.v1.CreateEngineMultiConfigResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.backoffice.enginemulticonfig.v1.CreateEngineMultiConfigRequest,
 *   !proto.witbooking.backoffice.enginemulticonfig.v1.CreateEngineMultiConfigResponse>}
 */
const methodInfo_EngineMultiConfigAPI_CreateEngineMultiConfig = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.backoffice.enginemulticonfig.v1.CreateEngineMultiConfigResponse,
  /**
   * @param {!proto.witbooking.backoffice.enginemulticonfig.v1.CreateEngineMultiConfigRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.enginemulticonfig.v1.CreateEngineMultiConfigResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.backoffice.enginemulticonfig.v1.CreateEngineMultiConfigRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.backoffice.enginemulticonfig.v1.CreateEngineMultiConfigResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.backoffice.enginemulticonfig.v1.CreateEngineMultiConfigResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.backoffice.enginemulticonfig.v1.EngineMultiConfigAPIClient.prototype.createEngineMultiConfig =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.backoffice.enginemulticonfig.v1.EngineMultiConfigAPI/CreateEngineMultiConfig',
      request,
      metadata || {},
      methodDescriptor_EngineMultiConfigAPI_CreateEngineMultiConfig,
      callback);
};


/**
 * @param {!proto.witbooking.backoffice.enginemulticonfig.v1.CreateEngineMultiConfigRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.backoffice.enginemulticonfig.v1.CreateEngineMultiConfigResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.backoffice.enginemulticonfig.v1.EngineMultiConfigAPIPromiseClient.prototype.createEngineMultiConfig =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.backoffice.enginemulticonfig.v1.EngineMultiConfigAPI/CreateEngineMultiConfig',
      request,
      metadata || {},
      methodDescriptor_EngineMultiConfigAPI_CreateEngineMultiConfig);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.backoffice.enginemulticonfig.v1.UpdateEngineMultiConfigRequest,
 *   !proto.witbooking.backoffice.enginemulticonfig.v1.UpdateEngineMultiConfigResponse>}
 */
const methodDescriptor_EngineMultiConfigAPI_UpdateEngineMultiConfig = new grpc.web.MethodDescriptor(
  '/witbooking.backoffice.enginemulticonfig.v1.EngineMultiConfigAPI/UpdateEngineMultiConfig',
  grpc.web.MethodType.UNARY,
  proto.witbooking.backoffice.enginemulticonfig.v1.UpdateEngineMultiConfigRequest,
  proto.witbooking.backoffice.enginemulticonfig.v1.UpdateEngineMultiConfigResponse,
  /**
   * @param {!proto.witbooking.backoffice.enginemulticonfig.v1.UpdateEngineMultiConfigRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.enginemulticonfig.v1.UpdateEngineMultiConfigResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.backoffice.enginemulticonfig.v1.UpdateEngineMultiConfigRequest,
 *   !proto.witbooking.backoffice.enginemulticonfig.v1.UpdateEngineMultiConfigResponse>}
 */
const methodInfo_EngineMultiConfigAPI_UpdateEngineMultiConfig = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.backoffice.enginemulticonfig.v1.UpdateEngineMultiConfigResponse,
  /**
   * @param {!proto.witbooking.backoffice.enginemulticonfig.v1.UpdateEngineMultiConfigRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.enginemulticonfig.v1.UpdateEngineMultiConfigResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.backoffice.enginemulticonfig.v1.UpdateEngineMultiConfigRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.backoffice.enginemulticonfig.v1.UpdateEngineMultiConfigResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.backoffice.enginemulticonfig.v1.UpdateEngineMultiConfigResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.backoffice.enginemulticonfig.v1.EngineMultiConfigAPIClient.prototype.updateEngineMultiConfig =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.backoffice.enginemulticonfig.v1.EngineMultiConfigAPI/UpdateEngineMultiConfig',
      request,
      metadata || {},
      methodDescriptor_EngineMultiConfigAPI_UpdateEngineMultiConfig,
      callback);
};


/**
 * @param {!proto.witbooking.backoffice.enginemulticonfig.v1.UpdateEngineMultiConfigRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.backoffice.enginemulticonfig.v1.UpdateEngineMultiConfigResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.backoffice.enginemulticonfig.v1.EngineMultiConfigAPIPromiseClient.prototype.updateEngineMultiConfig =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.backoffice.enginemulticonfig.v1.EngineMultiConfigAPI/UpdateEngineMultiConfig',
      request,
      metadata || {},
      methodDescriptor_EngineMultiConfigAPI_UpdateEngineMultiConfig);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.backoffice.enginemulticonfig.v1.DeleteEngineMultiConfigRequest,
 *   !proto.witbooking.backoffice.enginemulticonfig.v1.DeleteEngineMultiConfigResponse>}
 */
const methodDescriptor_EngineMultiConfigAPI_DeleteEngineMultiConfig = new grpc.web.MethodDescriptor(
  '/witbooking.backoffice.enginemulticonfig.v1.EngineMultiConfigAPI/DeleteEngineMultiConfig',
  grpc.web.MethodType.UNARY,
  proto.witbooking.backoffice.enginemulticonfig.v1.DeleteEngineMultiConfigRequest,
  proto.witbooking.backoffice.enginemulticonfig.v1.DeleteEngineMultiConfigResponse,
  /**
   * @param {!proto.witbooking.backoffice.enginemulticonfig.v1.DeleteEngineMultiConfigRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.enginemulticonfig.v1.DeleteEngineMultiConfigResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.backoffice.enginemulticonfig.v1.DeleteEngineMultiConfigRequest,
 *   !proto.witbooking.backoffice.enginemulticonfig.v1.DeleteEngineMultiConfigResponse>}
 */
const methodInfo_EngineMultiConfigAPI_DeleteEngineMultiConfig = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.backoffice.enginemulticonfig.v1.DeleteEngineMultiConfigResponse,
  /**
   * @param {!proto.witbooking.backoffice.enginemulticonfig.v1.DeleteEngineMultiConfigRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.enginemulticonfig.v1.DeleteEngineMultiConfigResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.backoffice.enginemulticonfig.v1.DeleteEngineMultiConfigRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.backoffice.enginemulticonfig.v1.DeleteEngineMultiConfigResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.backoffice.enginemulticonfig.v1.DeleteEngineMultiConfigResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.backoffice.enginemulticonfig.v1.EngineMultiConfigAPIClient.prototype.deleteEngineMultiConfig =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.backoffice.enginemulticonfig.v1.EngineMultiConfigAPI/DeleteEngineMultiConfig',
      request,
      metadata || {},
      methodDescriptor_EngineMultiConfigAPI_DeleteEngineMultiConfig,
      callback);
};


/**
 * @param {!proto.witbooking.backoffice.enginemulticonfig.v1.DeleteEngineMultiConfigRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.backoffice.enginemulticonfig.v1.DeleteEngineMultiConfigResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.backoffice.enginemulticonfig.v1.EngineMultiConfigAPIPromiseClient.prototype.deleteEngineMultiConfig =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.backoffice.enginemulticonfig.v1.EngineMultiConfigAPI/DeleteEngineMultiConfig',
      request,
      metadata || {},
      methodDescriptor_EngineMultiConfigAPI_DeleteEngineMultiConfig);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.backoffice.enginemulticonfig.v1.GetAllEngineMultiConfigRequest,
 *   !proto.witbooking.backoffice.enginemulticonfig.v1.GetAllEngineMultiConfigResponse>}
 */
const methodDescriptor_EngineMultiConfigAPI_GetAllEngineMultiConfig = new grpc.web.MethodDescriptor(
  '/witbooking.backoffice.enginemulticonfig.v1.EngineMultiConfigAPI/GetAllEngineMultiConfig',
  grpc.web.MethodType.UNARY,
  proto.witbooking.backoffice.enginemulticonfig.v1.GetAllEngineMultiConfigRequest,
  proto.witbooking.backoffice.enginemulticonfig.v1.GetAllEngineMultiConfigResponse,
  /**
   * @param {!proto.witbooking.backoffice.enginemulticonfig.v1.GetAllEngineMultiConfigRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.enginemulticonfig.v1.GetAllEngineMultiConfigResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.backoffice.enginemulticonfig.v1.GetAllEngineMultiConfigRequest,
 *   !proto.witbooking.backoffice.enginemulticonfig.v1.GetAllEngineMultiConfigResponse>}
 */
const methodInfo_EngineMultiConfigAPI_GetAllEngineMultiConfig = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.backoffice.enginemulticonfig.v1.GetAllEngineMultiConfigResponse,
  /**
   * @param {!proto.witbooking.backoffice.enginemulticonfig.v1.GetAllEngineMultiConfigRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.enginemulticonfig.v1.GetAllEngineMultiConfigResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.backoffice.enginemulticonfig.v1.GetAllEngineMultiConfigRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.backoffice.enginemulticonfig.v1.GetAllEngineMultiConfigResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.backoffice.enginemulticonfig.v1.GetAllEngineMultiConfigResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.backoffice.enginemulticonfig.v1.EngineMultiConfigAPIClient.prototype.getAllEngineMultiConfig =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.backoffice.enginemulticonfig.v1.EngineMultiConfigAPI/GetAllEngineMultiConfig',
      request,
      metadata || {},
      methodDescriptor_EngineMultiConfigAPI_GetAllEngineMultiConfig,
      callback);
};


/**
 * @param {!proto.witbooking.backoffice.enginemulticonfig.v1.GetAllEngineMultiConfigRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.backoffice.enginemulticonfig.v1.GetAllEngineMultiConfigResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.backoffice.enginemulticonfig.v1.EngineMultiConfigAPIPromiseClient.prototype.getAllEngineMultiConfig =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.backoffice.enginemulticonfig.v1.EngineMultiConfigAPI/GetAllEngineMultiConfig',
      request,
      metadata || {},
      methodDescriptor_EngineMultiConfigAPI_GetAllEngineMultiConfig);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.backoffice.enginemulticonfig.v1.GetEngineMultiConfigRequest,
 *   !proto.witbooking.backoffice.enginemulticonfig.v1.GetEngineMultiConfigResponse>}
 */
const methodDescriptor_EngineMultiConfigAPI_GetEngineMultiConfig = new grpc.web.MethodDescriptor(
  '/witbooking.backoffice.enginemulticonfig.v1.EngineMultiConfigAPI/GetEngineMultiConfig',
  grpc.web.MethodType.UNARY,
  proto.witbooking.backoffice.enginemulticonfig.v1.GetEngineMultiConfigRequest,
  proto.witbooking.backoffice.enginemulticonfig.v1.GetEngineMultiConfigResponse,
  /**
   * @param {!proto.witbooking.backoffice.enginemulticonfig.v1.GetEngineMultiConfigRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.enginemulticonfig.v1.GetEngineMultiConfigResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.backoffice.enginemulticonfig.v1.GetEngineMultiConfigRequest,
 *   !proto.witbooking.backoffice.enginemulticonfig.v1.GetEngineMultiConfigResponse>}
 */
const methodInfo_EngineMultiConfigAPI_GetEngineMultiConfig = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.backoffice.enginemulticonfig.v1.GetEngineMultiConfigResponse,
  /**
   * @param {!proto.witbooking.backoffice.enginemulticonfig.v1.GetEngineMultiConfigRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.enginemulticonfig.v1.GetEngineMultiConfigResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.backoffice.enginemulticonfig.v1.GetEngineMultiConfigRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.backoffice.enginemulticonfig.v1.GetEngineMultiConfigResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.backoffice.enginemulticonfig.v1.GetEngineMultiConfigResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.backoffice.enginemulticonfig.v1.EngineMultiConfigAPIClient.prototype.getEngineMultiConfig =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.backoffice.enginemulticonfig.v1.EngineMultiConfigAPI/GetEngineMultiConfig',
      request,
      metadata || {},
      methodDescriptor_EngineMultiConfigAPI_GetEngineMultiConfig,
      callback);
};


/**
 * @param {!proto.witbooking.backoffice.enginemulticonfig.v1.GetEngineMultiConfigRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.backoffice.enginemulticonfig.v1.GetEngineMultiConfigResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.backoffice.enginemulticonfig.v1.EngineMultiConfigAPIPromiseClient.prototype.getEngineMultiConfig =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.backoffice.enginemulticonfig.v1.EngineMultiConfigAPI/GetEngineMultiConfig',
      request,
      metadata || {},
      methodDescriptor_EngineMultiConfigAPI_GetEngineMultiConfig);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.backoffice.enginemulticonfig.v1.GetEngineMultiConfigByTickerRequest,
 *   !proto.witbooking.backoffice.enginemulticonfig.v1.GetEngineMultiConfigByTickerResponse>}
 */
const methodDescriptor_EngineMultiConfigAPI_GetEngineMultiConfigByTicker = new grpc.web.MethodDescriptor(
  '/witbooking.backoffice.enginemulticonfig.v1.EngineMultiConfigAPI/GetEngineMultiConfigByTicker',
  grpc.web.MethodType.UNARY,
  proto.witbooking.backoffice.enginemulticonfig.v1.GetEngineMultiConfigByTickerRequest,
  proto.witbooking.backoffice.enginemulticonfig.v1.GetEngineMultiConfigByTickerResponse,
  /**
   * @param {!proto.witbooking.backoffice.enginemulticonfig.v1.GetEngineMultiConfigByTickerRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.enginemulticonfig.v1.GetEngineMultiConfigByTickerResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.backoffice.enginemulticonfig.v1.GetEngineMultiConfigByTickerRequest,
 *   !proto.witbooking.backoffice.enginemulticonfig.v1.GetEngineMultiConfigByTickerResponse>}
 */
const methodInfo_EngineMultiConfigAPI_GetEngineMultiConfigByTicker = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.backoffice.enginemulticonfig.v1.GetEngineMultiConfigByTickerResponse,
  /**
   * @param {!proto.witbooking.backoffice.enginemulticonfig.v1.GetEngineMultiConfigByTickerRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.enginemulticonfig.v1.GetEngineMultiConfigByTickerResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.backoffice.enginemulticonfig.v1.GetEngineMultiConfigByTickerRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.backoffice.enginemulticonfig.v1.GetEngineMultiConfigByTickerResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.backoffice.enginemulticonfig.v1.GetEngineMultiConfigByTickerResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.backoffice.enginemulticonfig.v1.EngineMultiConfigAPIClient.prototype.getEngineMultiConfigByTicker =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.backoffice.enginemulticonfig.v1.EngineMultiConfigAPI/GetEngineMultiConfigByTicker',
      request,
      metadata || {},
      methodDescriptor_EngineMultiConfigAPI_GetEngineMultiConfigByTicker,
      callback);
};


/**
 * @param {!proto.witbooking.backoffice.enginemulticonfig.v1.GetEngineMultiConfigByTickerRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.backoffice.enginemulticonfig.v1.GetEngineMultiConfigByTickerResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.backoffice.enginemulticonfig.v1.EngineMultiConfigAPIPromiseClient.prototype.getEngineMultiConfigByTicker =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.backoffice.enginemulticonfig.v1.EngineMultiConfigAPI/GetEngineMultiConfigByTicker',
      request,
      metadata || {},
      methodDescriptor_EngineMultiConfigAPI_GetEngineMultiConfigByTicker);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.backoffice.enginemulticonfig.v1.GetEngineMultiConfigDefaultSerializeRequest,
 *   !proto.witbooking.backoffice.enginemulticonfig.v1.GetEngineMultiConfigDefaultSerializeResponse>}
 */
const methodDescriptor_EngineMultiConfigAPI_GetEngineMultiConfigDefaultSerialize = new grpc.web.MethodDescriptor(
  '/witbooking.backoffice.enginemulticonfig.v1.EngineMultiConfigAPI/GetEngineMultiConfigDefaultSerialize',
  grpc.web.MethodType.UNARY,
  proto.witbooking.backoffice.enginemulticonfig.v1.GetEngineMultiConfigDefaultSerializeRequest,
  proto.witbooking.backoffice.enginemulticonfig.v1.GetEngineMultiConfigDefaultSerializeResponse,
  /**
   * @param {!proto.witbooking.backoffice.enginemulticonfig.v1.GetEngineMultiConfigDefaultSerializeRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.enginemulticonfig.v1.GetEngineMultiConfigDefaultSerializeResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.backoffice.enginemulticonfig.v1.GetEngineMultiConfigDefaultSerializeRequest,
 *   !proto.witbooking.backoffice.enginemulticonfig.v1.GetEngineMultiConfigDefaultSerializeResponse>}
 */
const methodInfo_EngineMultiConfigAPI_GetEngineMultiConfigDefaultSerialize = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.backoffice.enginemulticonfig.v1.GetEngineMultiConfigDefaultSerializeResponse,
  /**
   * @param {!proto.witbooking.backoffice.enginemulticonfig.v1.GetEngineMultiConfigDefaultSerializeRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.enginemulticonfig.v1.GetEngineMultiConfigDefaultSerializeResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.backoffice.enginemulticonfig.v1.GetEngineMultiConfigDefaultSerializeRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.backoffice.enginemulticonfig.v1.GetEngineMultiConfigDefaultSerializeResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.backoffice.enginemulticonfig.v1.GetEngineMultiConfigDefaultSerializeResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.backoffice.enginemulticonfig.v1.EngineMultiConfigAPIClient.prototype.getEngineMultiConfigDefaultSerialize =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.backoffice.enginemulticonfig.v1.EngineMultiConfigAPI/GetEngineMultiConfigDefaultSerialize',
      request,
      metadata || {},
      methodDescriptor_EngineMultiConfigAPI_GetEngineMultiConfigDefaultSerialize,
      callback);
};


/**
 * @param {!proto.witbooking.backoffice.enginemulticonfig.v1.GetEngineMultiConfigDefaultSerializeRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.backoffice.enginemulticonfig.v1.GetEngineMultiConfigDefaultSerializeResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.backoffice.enginemulticonfig.v1.EngineMultiConfigAPIPromiseClient.prototype.getEngineMultiConfigDefaultSerialize =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.backoffice.enginemulticonfig.v1.EngineMultiConfigAPI/GetEngineMultiConfigDefaultSerialize',
      request,
      metadata || {},
      methodDescriptor_EngineMultiConfigAPI_GetEngineMultiConfigDefaultSerialize);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.backoffice.enginemulticonfig.v1.ValidateEngineMultiConfigSerializeRequest,
 *   !proto.witbooking.backoffice.enginemulticonfig.v1.ValidateEngineMultiConfigSerializeResponse>}
 */
const methodDescriptor_EngineMultiConfigAPI_ValidateEngineMultiConfigSerialize = new grpc.web.MethodDescriptor(
  '/witbooking.backoffice.enginemulticonfig.v1.EngineMultiConfigAPI/ValidateEngineMultiConfigSerialize',
  grpc.web.MethodType.UNARY,
  proto.witbooking.backoffice.enginemulticonfig.v1.ValidateEngineMultiConfigSerializeRequest,
  proto.witbooking.backoffice.enginemulticonfig.v1.ValidateEngineMultiConfigSerializeResponse,
  /**
   * @param {!proto.witbooking.backoffice.enginemulticonfig.v1.ValidateEngineMultiConfigSerializeRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.enginemulticonfig.v1.ValidateEngineMultiConfigSerializeResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.backoffice.enginemulticonfig.v1.ValidateEngineMultiConfigSerializeRequest,
 *   !proto.witbooking.backoffice.enginemulticonfig.v1.ValidateEngineMultiConfigSerializeResponse>}
 */
const methodInfo_EngineMultiConfigAPI_ValidateEngineMultiConfigSerialize = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.backoffice.enginemulticonfig.v1.ValidateEngineMultiConfigSerializeResponse,
  /**
   * @param {!proto.witbooking.backoffice.enginemulticonfig.v1.ValidateEngineMultiConfigSerializeRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.enginemulticonfig.v1.ValidateEngineMultiConfigSerializeResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.backoffice.enginemulticonfig.v1.ValidateEngineMultiConfigSerializeRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.backoffice.enginemulticonfig.v1.ValidateEngineMultiConfigSerializeResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.backoffice.enginemulticonfig.v1.ValidateEngineMultiConfigSerializeResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.backoffice.enginemulticonfig.v1.EngineMultiConfigAPIClient.prototype.validateEngineMultiConfigSerialize =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.backoffice.enginemulticonfig.v1.EngineMultiConfigAPI/ValidateEngineMultiConfigSerialize',
      request,
      metadata || {},
      methodDescriptor_EngineMultiConfigAPI_ValidateEngineMultiConfigSerialize,
      callback);
};


/**
 * @param {!proto.witbooking.backoffice.enginemulticonfig.v1.ValidateEngineMultiConfigSerializeRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.backoffice.enginemulticonfig.v1.ValidateEngineMultiConfigSerializeResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.backoffice.enginemulticonfig.v1.EngineMultiConfigAPIPromiseClient.prototype.validateEngineMultiConfigSerialize =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.backoffice.enginemulticonfig.v1.EngineMultiConfigAPI/ValidateEngineMultiConfigSerialize',
      request,
      metadata || {},
      methodDescriptor_EngineMultiConfigAPI_ValidateEngineMultiConfigSerialize);
};


module.exports = proto.witbooking.backoffice.enginemulticonfig.v1;

